import { render, staticRenderFns } from "./StudentAddOrEdit.vue?vue&type=template&id=96eeddd4&scoped=true&"
import script from "./StudentAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./StudentAddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./StudentAddOrEdit.vue?vue&type=style&index=0&id=96eeddd4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96eeddd4",
  null
  
)

export default component.exports